export default __webpack_public_path__ + "static/media/z-1-character.c7edbf48.svg";